import { HttpResponse } from '@angular/common/http';

export function getFilename(response: HttpResponse<Blob>): string | undefined {
  const contentDisposition = response.headers.get('content-disposition');
  if (!contentDisposition) return undefined;

  const filename = contentDisposition
    .split(';')[1]
    .split('filename')[1]
    .split('=')[1]
    .trim()
    .match(/"([^"]+)"/)[1];

  return filename;
}
